<template>
  <div style="display: flex; flex-direction: column">
    <cargo-advance-select
      :select-type="TYPE_NAMES.basic_data_CargoInformation"
      :disabled="disabled"
      filterable
      :clearable="true"
      :default-value="job.cargoCode"
      :allow-create="false"
      @parentCallBack="p=>{job.cargoCode=p.value;onChange('cargoCode')}"
    />
    <el-input
      v-model="job.cargoName"
      :disabled="disabled || !job.cargoCode"
      style="margin-top: 5px"
      @change="onChange('cargoName')"
    />
  </div>
</template>

<script>
import cargoAdvanceSelect from '@/components/Cargo/Common/cargoAdvanceSelect'
import { TYPE_NAMES } from '@/utils/class/AdvanceSelect'

export default {
  name: 'SeCargoCode',
  components: { cargoAdvanceSelect },
  props: {
    job: { type: Object, default: () => { return {} } },
    disabled: { type: Boolean, default: false }
  },
  data() {
    return {
      TYPE_NAMES
    }
  },
  methods: {
    onChange(key) {
      this.$emit('childrenChange', [{ key, value: this.job[key] }])
    }
  }
}
</script>
